<section class="selec-banner">
    <div class="container">
        <h2>Why Work For Us?</h2>
        <p>We are a <strong>technology company;</strong> having complete <strong>indigenous development.</strong> For us, <strong>creation</strong> is a way of life, with equal focus on its translation to commercial success. We have unlimited opportunities arising from our reputation with the large base of our customers and channel partners. We love to design innovative products and processes that solves the needs of maximum number of customers, in the shortest time and the best value.</p>
        <p>We aspire to also be a major contributor in <strong>nation building,</strong> by providing ample opportunities to engineers to pursue <strong>core engineering,</strong> which is a critical need in India at the moment.</p>
        <div class="joblist-btn">
            <a [routerLink]="['/jobslist']">View Open Roles</a>
        </div>
    </div>
</section>
<section class="selec-grid">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Who Are We Looking For?</h2>
                <div class="row">
                    <div class="col-md-6">
                        <img class="left-img" src="assets/left.webp" width="180" height="148" alt="Selec">
                    </div>
                    <div class="col-md-6">
                        <p class="selec-grid-para">We always look for emotionally mature and passionate professionals, who love their vocation and our <strong>nation.</strong></p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 pd-left">
                <h2>What We Offer?</h2>
                <div class="row">
                    <div class="col-md-6">
                        <img class="right-img" src="assets/right.webp" width="180" height="180" alt="Selec">
                    </div>
                    <div class="col-md-6">
                        <p class="selec-grid-para">We give all possible opportunities to learn through experience to young professionals. Our flat organization structure, team-based working, strongly supported by the mechanisms for meritocracy recognition helps all bright employees to grow faster. We offer the <strong>culture of trust, collaboration, excellence</strong> and <strong>freedom</strong> of <strong>work.</strong> Best <strong>talent</strong> is identified at very early stage & is given excellent career progression.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="selec-box">
    <div class="container">
        <h2>Our DNA</h2>
        <div class="selec-box-contain">
            <div class="selec-box-contain-icon">
                <img src="assets/b1.png" alt="Benefits" width="44" height="45">
                <p>Trust</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b2.png" alt="Benefits" width="44" height="45">
                <p>Collaboration</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b3.png" alt="Benefits" width="44" height="45">
                <p>Excellence</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b4.png" alt="Benefits" width="44" height="45">
                <p>Innovation</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b5.png" alt="Benefits" width="44" height="45">
                <p>Empowerment</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b6.png" alt="Benefits" width="44" height="45">
                <p>Meritocracy</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b3-s.png" alt="Benefits" width="44" height="45">
                <p>Openness</p>
            </div>
            <div class="selec-box-contain-icon">
                <img src="assets/b7.png" alt="Benefits" width="44" height="45">
                <p>Honesty</p>
            </div>
        </div>
        <div class="joblist-btn-two">
            <a class="joblist-btn-one" [routerLink]="['/jobslist']">View Open Roles</a>
        </div>
        <p style="text-align:center;font-size: 14px;color:#808281;">In case you do not find suitable openings as of now, &nbsp;please feel free to mail your cv at <a style="color: #ff8e25;" href="mailto:career@selec.com">career@selec.com</a></p>
    </div>
</section>